import React from "react";
import { ShimmerEffect } from "components/shimmer";
import { cn, HEADER_CONTENT_PORTAL_ID, UI_ACTION_PORTAL_ID } from "utils";
import { usePortal } from "hooks/src";
import { Portal } from "@radix-ui/react-portal";

const TimesheetLogDayLoader = ({ cardCount = 7 }) => {
  const headerContentPortal = usePortal({
    elementId: HEADER_CONTENT_PORTAL_ID,
  });

  const uiActionPortal = usePortal({
    elementId: UI_ACTION_PORTAL_ID,
  });

  return (
    <div role="region" aria-label="Timesheet entries" className=" lg:px-6 px-4">
      <Portal container={headerContentPortal}>
        <div>
          <div className="">
            <ShimmerEffect className="w-60 h-8 " />
            <ShimmerEffect className="w-40 h-6  mt-2" />
          </div>{" "}
        </div>
      </Portal>
      {/* <Portal container={uiActionPortal}>
        <div className="flex gap-6 justify-end items-center flex-row-reverse md:flex-row order-2">
          <ShimmerEffect className="w-32 h-8" />
        </div>
      </Portal> */}
      <div
        role="list"
        aria-label="Timesheet entries list"
        className={" flex flex-wrap gap-4.5  py-1 "}
      >
        {Array.from({ length: cardCount }).map((_, cardIndex) => (
          <ShimmerEffect
            key={cardIndex}
            className={cn("flex-shrink-0 w-80 h-40 rounded-lg overflow-hidden")}
          />
        ))}

        <div className="sr-only">Loading timesheet entries...</div>
      </div>
    </div>
  );
};

export default TimesheetLogDayLoader;
